import { Flex, Skeleton, Spin, Typography } from "antd";
import { observer } from "mobx-react-lite";
import { useStores } from "stores";
import { PlateList, PlateItem } from "components/PlateList";

import { getColumns } from "./getColumns";

import { CountBadge, WhiteBoxBlock } from "ui";
import { BidTransactionList } from "stores/BidTransactionList";
import { BidTransactionGridDto } from "interfaces";
import { useMemo } from "react";

export const TransactionList = observer(() => {
  const { bidTransactions, bidCard, user } = useStores();

  const count = bidTransactions.allData.length ?? 0;

  const columns = useMemo(() => {
    return getColumns(user, bidCard.bid);
  }, [bidCard.bid, count]);

  return (
    <WhiteBoxBlock
      collapse={{
        title: (
          <Flex justify="space-between" align="center">
            <Flex gap={4} align="center">
              <Typography.Text className="whitebox-title">Транзакции</Typography.Text>
              {count > 0 && <CountBadge count={count} />}
            </Flex>
          </Flex>
        ),
        defaultOpen: true,
      }}
    >
      <Flex vertical gap="large">
        {bidTransactions.fetchStatus === "fetching" ? (
          <Skeleton active />
        ) : (
          <PlateList<BidTransactionGridDto, BidTransactionList>
            store={bidTransactions}
            columns={columns}
            PlateComponent={PlateItem}
            updateWithInterval
            emptyProps={{
              description: "Транзакции не найдены",
            }}
            errorMessage="Ошибка загрузки транзакций"
            showHeader
            showPagination
          />
        )}
      </Flex>
    </WhiteBoxBlock>
  );
});
